import Service from 'react-reservice';

import chartAnalysisService from './chart/chartAnalysisService';
import featurePopupAnalysisService from './featurePopup/featurePopupAnalaysisService';
import orderAnalysisService from './order/orderAnalysisService';
import pageAnalaysisService from './page/pageAnalaysisService';
import signalAnalysisService from './signal/signalAnalysisService';
import superPropertiesService from './superProperties/superPropertiesService';
import userAnalysisService from './user/userAnalysisService';

class MixpanelAnalysisService extends Service {
  public user = userAnalysisService;
  public superProperties = superPropertiesService;
  public order = orderAnalysisService;
  public page = pageAnalaysisService;
  public chart = chartAnalysisService;
  public featurePopup = featurePopupAnalysisService;
  public signal = signalAnalysisService;
}

const mixpanelAnalysisService = new MixpanelAnalysisService();
export default mixpanelAnalysisService;
